/**
 * An array of default lorem ipsum words.
 */
export const DEFAULT_WORDS = [
  'ad',
  'adipisicing',
  'aliqua',
  'aliquip',
  'amet',
  'anim',
  'aute',
  'cillum',
  'commodo',
  'consectetur',
  'consequat',
  'culpa',
  'cupidatat',
  'deserunt',
  'do',
  'dolor',
  'dolore',
  'duis',
  'ea',
  'eiusmod',
  'elit',
  'enim',
  'esse',
  'est',
  'et',
  'eu',
  'ex',
  'excepteur',
  'exercitation',
  'fugiat',
  'id',
  'in',
  'incididunt',
  'ipsum',
  'irure',
  'labore',
  'laboris',
  'laborum',
  'Lorem',
  'magna',
  'minim',
  'mollit',
  'nisi',
  'non',
  'nostrud',
  'nulla',
  'occaecat',
  'officia',
  'pariatur',
  'proident',
  'qui',
  'quis',
  'reprehenderit',
  'sint',
  'sit',
  'sunt',
  'tempor',
  'ullamco',
  'ut',
  'velit',
  'veniam',
  'voluptate',
];

/**
 * An array of vegan-related words to accompany the default ones.
 */
export const VEGAN_WORDS = [
  'plant',
  'vegan',
  'kindness',
  'crueltyfree',
  'herbivore',
  'compassion',
  'earth',
  'dairyfree',
  'justice',
  'respect',
  'peace',
  'love',
  'greens',
  'fruit',
  'vegetable',
  'freedom',
  'life',
  'rights',
  'sanctuary',
  'nonviolence',
  'care',
  'conscious',
  'ethics',
  'climate',
  'truth',
  'plants',
  'health',
  'wholefood',
  'clean',
  'veggie',
  'legumes',
  'fiber',
  'avocado',
  'soy',
  'tofu',
  'tempeh',
  'lentils',
  'coconut',
  'nutrients',
  'plantpower',
  'choices',
  'saving',
  'sustain',
  'grain',
  'beans',
  'peas',
  'quinoa',
  'broccoli',
  'kale',
  'lettuce',
  'radish',
  'basil',
  'mint',
  'ginger',
  'turmeric',
  'natural',
  'organic',
  'kind',
];

/**
 * An array of kindness-related words to accompany the default ones.
 */
export const KINDNESS_WORDS = [
  'kindness',
  'compassion',
  'empathy',
  'mercy',
  'respect',
  'gentleness',
  'care',
  'love',
  'peace',
  'justice',
  'fairness',
  'awareness',
  'forgiveness',
  'integrity',
  'nonviolence',
  'harmony',
  'mindfulness',
  'humility',
  'patience',
  'sincerity',
  'tolerance',
  'understanding',
  'altruism',
  'grace',
  'generosity',
  'helpfulness',
  'selflessness',
  'support',
  'comfort',
  'sympathy',
  'warmth',
  'charity',
  'unity',
  'positivity',
];

/**
 * An array of vegan food-related words to accompany the default ones.
 */
export const VEGAN_FOOD_WORDS = [
  'tofu',
  'tempeh',
  'soymilk',
  'almondmilk',
  'oatmilk',
  'vegan-burger',
  'vegan-cheese',
  'jackfruit',
  'quinoa',
  'bowl',
  'lentil',
  'soup',
  'smoothie',
  'nut',
  'chia',
  'pudding',
  'granola',
  'plant-based',
  'vegan-yogurt',
  'vegan-pizza',
  'coconut',
  'chickpea',
  'curry',
  'soba',
  'noodles',
  'pancake',
  'avocado',
  'toast',
  'vegetable',
];

/**
 * An array of vegetable-related words to accompany the default ones.
 */
export const VEGGIE_WORDS = [
  'broccoli',
  'kale',
  'spinach',
  'lettuce',
  'cabbage',
  'beetroot',
  'carrot',
  'radish',
  'turnip',
  'cauliflower',
  'zucchini',
  'bell',
  'pepper',
  'cucumber',
  'eggplant',
  'okra',
  'tomato',
  'green',
  'beans',
  'peas',
  'sweet',
  'potato',
  'pumpkin',
  'asparagus',
  'artichoke',
  'brussels',
  'sprouts',
  'chard',
  'fennel',
  'leek',
  'parsnip',
  'celery',
  'shallot',
  'corn',
  'bamboo',
  'shoots',
  'beet',
  'greens',
  'mustard',
  'scallions',
  'radicchio',
  'snow',
  'onion',
  'squash',
];

/**
 * Final array combining default lorem ipsum and vegan-themed words.
 */
export const WORDS = Array.from(
  new Set([...DEFAULT_WORDS, ...VEGAN_WORDS, ...KINDNESS_WORDS, ...VEGAN_FOOD_WORDS, ...VEGGIE_WORDS])
);
